import type { AppPlugin } from '@capacitor/app';
import type { router as Router } from '../routes';
import { useUi } from '../store/ui';

/**
 * Android back: close what is open, leave a sub-page, step back through the columns
 * visited, then leave the app. Registering the listener disables the system default.
 */
export function installBackButton(app: AppPlugin, router: typeof Router): void {
  void app.addListener('backButton', () => {
    const ui = useUi.getState();
    if (ui.sheetCardId) {
      ui.closeSheet();
      return;
    }
    if (ui.quickAdd.open) {
      ui.closeQuickAdd();
      return;
    }
    if (ui.boardMenu) {
      ui.setBoardMenu(false);
      return;
    }
    if (router.state.location.pathname !== '/') {
      void router.navigate('/');
      return;
    }
    const previous = ui.popColumnHistory();
    if (previous !== null) {
      ui.jumpTo(previous);
      return;
    }
    void app.exitApp();
  });
}
